module.exports = __webpack_public_path__ + "static/media/midl2023.e7c37c25.png";